import { render, staticRenderFns } from "./SuccessScreen.vue?vue&type=template&id=49acf074&scoped=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"
import style0 from "./SuccessScreen.vue?vue&type=style&index=0&id=49acf074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acf074",
  null
  
)

export default component.exports